import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import BookingApi from '../../functions/api/booking/BookingApi';
import dayjs from 'dayjs';
import MyUtil from '../../functions/MyUtil';

interface Prop {
  customerId: number;
}

type Booking = {
  code: string;
  vehicleName: string;
  deliverAddress: string;
  partnerAddress: string;
  partnerName: string;
  partnerStatus: number;
  rentalDate: string;
  returnDate: string;
  dayQuantity: number;
  priceTotal: number;
  paidAmount: number;
  bookingStatus: number;
};

const BOOKING_STATUS = {
  PENDING: 0,
  NOTIFIED: 1,
  ACCEPTED: 10,
  DENIED: 20,
};

function RentaHistory(props: Prop) {
  const [listBooking, setListBooking] = useState([]);
  const [bookings, setBookings] = useState([]);
  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const listBooking = await BookingApi.getBookingByUser(props.customerId);
    setListBooking(listBooking);
  }

  function getBookingStatusName(status: number) {
    for (let [key, value] of Object.entries(BOOKING_STATUS)) {
      if (value === status) {
        return key;
      }
    }
  }

  function getBookingStatus(cell: any, row: Booking) {
    return getBookingStatusName(row.bookingStatus);
  }

  const getPartnerStatusName = (cell: any, row: Booking) => {
    return row.partnerStatus === 1 ? 'ACTIVE' : 'INACTIVE';
  };

  const getCarPartner = (cell: any, row: Booking) => {
    return (
      <div>
        <p className="font-weight-bold">{row.vehicleName}</p>
        <p>
          {`Từ ${dayjs(row.rentalDate).format('HH:mm')}`}
          Nhận tại:{' '}
          {row.deliverAddress !== null
            ? row.deliverAddress
            : row.partnerAddress}
          <p>-</p>
          {`Từ ${dayjs(row.rentalDate).format('HH:mm')} |  ${dayjs(
            row.rentalDate
          ).format('DD/MM')} đến ${dayjs(row.returnDate).format(
            'HH:mm'
          )} |  ${dayjs(row.returnDate).format('DD/MM')} (${
            row.dayQuantity
          } ngày)
    `}
          <p>-</p>
          <p className="font-weight-bold">Đối tác: {row.partnerName}</p>
          <p>{row.partnerAddress}</p>
          <p>
            Tổng tiền:
            {` ${MyUtil.currencyFormat(row.priceTotal)}đ`}
          </p>
          <p>
            Đã thanh toán:
            {` ${MyUtil.currencyFormat(row.paidAmount)}đ`}
          </p>
        </p>
      </div>
    );
  };

  const columns = [
    {
      title: 'Mã đơn',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Xe & đối tác',
      dataIndex: 'car_partner',
      key: 'car_partner',
      render: getCarPartner,
    },
    {
      title: 'Trạng thái đơn',
      dataIndex: 'booking_status',
      key: 'booking_status',
      render: getBookingStatus,
    },
    {
      title: 'Trạng thái đối tác',
      dataIndex: 'partner_status',
      key: 'partner_status',
      render: getPartnerStatusName,
    },
  ];

  return (
    <>
      <Table dataSource={listBooking} columns={columns} className="mt-5" />
    </>
  );
}

export default RentaHistory;
